export default [
    {
        path: "/tenant",
        name: "tenant-setting",
        meta: {
            title: "Tenant Setting",
            authRequired: true,
            resource: 'Tenant',
            action: 'tenant-setting.view',
            application: 'administration',
            breadcrumb: () => [
                { text: 't-tenant', to: null, class: 'text-dark' },
                { text: 't-setting', to: null }
            ]
        },
        component: () => import("@/views/tenant/setting"),
    },
    {
        path: "/merchants",
        name: "tenant-merchants",
        meta: {
            title: "Merchants",
            authRequired: true,
            resource: 'Tenant',
            action: 'cas.merchant.merchants.view',
            application: 'administration',
            breadcrumb: () => [
                { text: 't-tenant', to: null, class: 'text-dark' },
                { text: 't-merchants', to: null }
            ]
        },
        component: () => import("@/views/merchants/index.vue"),
    },
];